import { useState, useEffect } from 'react';
import apiService from '../services/api';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if we have a valid token
        const hasValidToken = apiService.isTokenValid();
        
        if (hasValidToken) {
          // Try to get user details to verify token is actually valid
          try {
            const userDetails = await apiService.getUserDetails();
            setIsAuthenticated(true);
            setUser(userDetails);
          } catch (error) {
            // Token is invalid or expired
            // console.log('Token validation failed:', error.message);
            apiService.clearToken();
            localStorage.removeItem('isAuthenticated');
            localStorage.removeItem('user');
            setIsAuthenticated(false);
            setUser(null);
          }
        } else {
          // No valid token
          setIsAuthenticated(false);
          setUser(null);
          localStorage.removeItem('isAuthenticated');
          localStorage.removeItem('user');
        }
      } catch (error) {
        // console.error('Auth check error:', error);
        setIsAuthenticated(false);
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = async (username, password) => {
    try {
      const response = await apiService.login(username, password);
      
      if (response.success) {
        // Get user details
        const userDetails = await apiService.getUserDetails();
        
        // Store authentication state
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('user', JSON.stringify({
          username: username,
          loginTime: new Date().toISOString(),
          ...userDetails
        }));
        
        setIsAuthenticated(true);
        setUser(userDetails);
        
        // Dispatch event to notify PermissionContext to reload permissions
        window.dispatchEvent(new CustomEvent('user-logged-in'));
        
        return { success: true };
      }
      
      return { success: false, message: 'Login failed' };
    } catch (error) {
      // console.error('Login error:', error);
      return { success: false, message: error.message };
    }
  };

  const logout = () => {
    apiService.clearCachedBusinessSettings();
    localStorage.clear();
    sessionStorage.clear();
    setIsAuthenticated(false);
    setUser(null);
  };

  return {
    isAuthenticated,
    isLoading,
    user,
    login,
    logout
  };
};
